import React, { useEffect, useState, Fragment, useMemo } from "react";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import FormModalContent from "./../orders/form";

import { useErrorHandler } from "../../../hooks";
import {
    Button,
    DialogActions,
    DialogContent,
    Divider,
    Grid,
    Link,
    Paper,
    Typography,
} from "@material-ui/core";
import DialogTitle from "../../../components/dialog-title";
import customersService from "../../../services/customers.service";
import LoadingComponent from "../../../components/loading";
import { dateFormat } from "../../../helpers/date-helpers";
import { currencyFormat, phoneFormat } from "../../../helpers";
import { ImageOutlined as ImageOutlinedIcon } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import { openImage } from "../../../redux/app";
import DataTable from "../../../components/data-table";
import ordersService from "../../../services/orders.service";
import brandsService from "../../../services/brands.service";
import glassesService from "../../../services/glasses.service";
import MuiAutocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "@material-ui/core";


const defaultKeys = [
    {
        field: "trackingCode",
        title: "کد رهگیری",
        active: true,
    },
    {
        field: "user.phoneNumber",
        title: "شماره تلفن",
        active: true,
    },
];

function addressString(address) {
    const { province, city, postalAddress, neighborhood } = address;
    return `${province.name}، ${city.name}، ${neighborhood}، ${postalAddress}`;
}

export default function InfoModalContent({ close, data }) {
    const { initials } = useSelector((state) => state.app);

    const { id, createDate, email, fullName, nationalCode, phoneNumber } = data;
    const [info, setInfo] = useState();
    const [options, setOptions] = useState({
        brands: []
    })
    const dispatch = useDispatch();
    const errorHandler = useErrorHandler();

    const headerCells = useMemo(
        () => [
            {
                field: "trackingCode",
                title: "کد رهگیری",
                disableSort: true,
            },
            {
                field: "user",
                title: "نام مشتری",
                renderer: (v) => <span className="">{v.fullName}</span>,
            },
            {
                field: "user",
                title: "شماره تلفن",
                renderer: (v) => <span className="en">{v.phoneNumber}</span>,
            },
            {
                field: "status",
                title: "وضعیت",
                disableSort: true,
                renderer: (v) =>
                    initials?.enums?.orderStatus?.find((s) => s.value === v)?.title || v,
            },
            {
                field: "totalAmount",
                title: "مبلغ فاکتور",
                renderer: (v) => currencyFormat(v),
            },
            {
                field: "deliveryDate",
                title: "تاریخ تحویل",
                date: true,
            },
            {
                field: "createDate",
                title: "تاریخ ایجاد",
                date: true,
            },
        ],
        [initials]
    );

    const filterForm = useMemo(
        () =>
            !initials || !options.brands
                ? undefined
                : {
                    form: [
                        {
                            _type: "autocomplete",
                            _empty: "",
                            name: "brandIds",
                            options: options.brands.map(item => ({ ...item, value: item.id, title: item.name })),
                            valueSelector: "value",
                            labelSelector: "title",
                            label: "برندها",
                            disableClearable: false,
                        },
                        {
                            _type: "customContent",
                            content: function SearchContent(values) {
                                const [selected, setSelected] = useState(null)
                                const [glasses, setGlasses] = useState([])
                                const searchInGlassTitle = async (e) => {
                                    const search = e.target.value;
                                    const res = await glassesService.getGlasses([`search=${search}`])
                                    setGlasses(res.data.items);
                                }

                                const getOptionLabel = () => {
                                    const labelSelector = "name";
                                    if (!labelSelector) return;
                                    if (typeof labelSelector === "string") {
                                        return (option) => `${option[labelSelector]}`;
                                    }
                                    return labelSelector;
                                };

                                const changeInGlassTitle = (e, value) => {
                                    if (!value) {
                                        values.setFieldValue("glassId", "")
                                        values.setFieldValue("glass", null)
                                        setSelected(null)
                                        return;
                                    }
                                    values.setFieldValue("glassId", value.id)
                                    values.setFieldValue("glass", value)
                                    setSelected(value)
                                }

                                return (
                                    <>
                                        <MuiAutocomplete
                                            name="glassId"
                                            multiple={false}
                                            options={glasses}
                                            onKeyUp={searchInGlassTitle}
                                            getOptionLabel={getOptionLabel()}
                                            defaultValue={values.values.glass}
                                            noOptionsText="هیچ گزینه ای یافت نشد."
                                            onChange={changeInGlassTitle}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    margin="normal"
                                                    variant="outlined"
                                                    fullWidth
                                                    label={"مدل عینک"}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <React.Fragment>
                                                                {params.InputProps.endAdornment}
                                                            </React.Fragment>
                                                        ),
                                                    }}
                                                />
                                            )}
                                        />
                                    </>
                                )
                            }
                        },
                        {
                            _type: "hidden",
                            _empty: id,
                            name: "userId"
                        },
                        {
                            _type: "autocomplete",
                            _empty: null,
                            name: "status",
                            options: initials.enums.orderStatus,
                            valueSelector: "value",
                            labelSelector: "title",
                            label: "وضعیت",
                        },
                    ],
                },
        [initials, options]
    );

    const getBrands = async () => {
        const brands = await brandsService.getAllBrands();
        setOptions(prev => ({
            ...prev,
            brands: brands.data
        }))
    }

    useEffect(() => {
        customersService.getCustomer(id).then(({ data, error }) => {
            if (error) {
                return errorHandler(error);
            }
            setInfo(data);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);


    useEffect(() => {
        getBrands()
    }, [])


    return (
        // <LoadingComponent isLoading={waiting} overlay>
        <>
            <DialogTitle onClose={() => close()}>کاربر</DialogTitle>
            <Divider />
            <DialogContent className="py-3">
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={4}>
                        <Typography>نام: {fullName}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Typography>
                            شماره تلفن: <span className="en">{phoneFormat(phoneNumber)}</span>
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Typography>کد ملی: {nationalCode}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Typography>ایمیل: {email}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Typography>تاریخ عضویت: {dateFormat(createDate)}</Typography>
                    </Grid>

                    {!info ? (
                        <LoadingComponent />
                    ) : (
                        <>
                            <Grid item xs={12} sm={6} md={4}>
                                <Typography>بیمه پایه: {info.basicInsurance?.name}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <Typography>
                                    بیمه تکمیلی: {info.supplementalInsurance?.name}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <Typography className="d-flex">
                                    نسخه:{" "}
                                    {info.prescription ? (
                                        <>
                                            <ImageOutlinedIcon
                                                onClick={() =>
                                                    dispatch(openImage(info.prescription.image))
                                                }
                                            />
                                            {info.prescription.isInvalid && "(رد شده)"}
                                        </>
                                    ) : (
                                        ""
                                    )}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <Typography className="d-flex">
                                    آخرین نسخه:{" "}
                                    {info.prescription?.updateDate
                                        ? dateFormat(info.prescription?.updateDate)
                                        : ""}
                                </Typography>
                            </Grid>
                            {Boolean(info.prescription?.description) && (
                                <Grid item xs={12}>
                                    <Typography className="d-flex">
                                        توضیحات نسخه: {info.prescription?.description}
                                    </Typography>
                                </Grid>
                            )}
                            {info?.addresses?.map((address) => (
                                <Fragment key={address.id}>
                                    <Grid item xs={12}>
                                        <Divider className="my-2" />
                                        <Typography variant="h5" className="d-flex">
                                            {address.name}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography className="d-flex">
                                            آدرس: {addressString(address)}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Typography>کد پستی: {address.postalCode}</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Typography>
                                            موقعیت:{" "}
                                            <Link
                                                target="_blank"
                                                rel="noreferrer"
                                                href={`https://www.google.com/maps/search/?api=1&query=${address.location}`}
                                            >
                                                {" "}
                                                {address.location}{" "}
                                            </Link>
                                        </Typography>
                                    </Grid>
                                </Fragment>
                            ))}
                        </>
                    )}
                </Grid>

                <Paper style={{ marginTop: "40px" }}>
                    <DataTable
                        headCells={headerCells}
                        searchKeys={defaultKeys}
                        rowActions={[{
                            modalProps: { maxWidth: "md" },
                            icon: <InfoOutlinedIcon />,
                            modalContent: (props) => <FormModalContent {...props} />,
                        }]}
                        backend={ordersService.getOrdersUrl}
                        title="سفارشات"
                        order={{ order: "ASC", orderBy: "createDate" }}
                        filterForm={filterForm}
                    />
                </Paper>
            </DialogContent>
        </>
        // </LoadingComponent>
    );
}
